import { MediaModel } from './media.model';

export class ProviderModel {
  media: MediaModel;
  description: string;
  id: string;
  name: string;

  // Default constructor will be called by mapper
  constructor() {
    this.media = undefined;
    this.description = undefined;
    this.id = undefined;
    this.name = undefined;
  }
}
